<template>
  <div class="container-fluid m-0 p-0" v-if="dataOtpFlags.otpStatus">
    <div v-if="dataConfirmContractStatus && !dataOtpFlags.confirmOtpStatus && !dataOtpFlags.sentOtpPass" class="col-lg-12 text-center position-relative">
      <button
          type="button"
          :disabled="!dataAgreement"
          v-on:click="formSendOtp()"
          class="btn btn-blue">
        Згенерувати код
      </button>
    </div>
    <div v-else-if="dataConfirmContractStatus && dataOtpFlags.sentOtpPass" class="col-lg-12 text-center position-relative">
      <div class="row">
        <div class="col-lg-6">
          <div v-if="dataOtpFlags.pandingOtpSending" class="flex items-center justify-center otp-wait-success-block">
            <svg class="pandingOtpLoader" width="60" height="58" viewBox="0 0 60 58" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="path-1-inside-1_1_825" fill="white">
                <path d="M41.2773 1.24879C41.4852 0.755711 42.0543 0.523082 42.5404 0.746755C48.0033 3.26042 52.5923 7.36197 55.7017 12.5267C58.9778 17.9684 60.4422 24.3096 59.8839 30.6369C59.3256 36.9641 56.7734 42.9509 52.595 47.7349C48.4166 52.5189 42.8275 55.8532 36.6329 57.2576C30.4382 58.6619 23.9577 58.0639 18.1247 55.5495C12.2917 53.0352 7.40725 48.7344 4.17491 43.2665C0.942573 37.7986 -0.470841 31.4458 0.138246 25.1233C0.716322 19.1226 3.08787 13.4431 6.93273 8.81924C7.27486 8.4078 7.88861 8.37228 8.28879 8.72751C8.68897 9.08274 8.72396 9.69413 8.38275 10.1063C4.80976 14.4227 2.60582 19.7168 2.06709 25.3091C1.49735 31.2233 2.81946 37.1656 5.84302 42.2804C8.86657 47.3951 13.4355 51.4181 18.8917 53.77C24.348 56.122 30.4099 56.6814 36.2044 55.3677C41.999 54.0541 47.227 50.9352 51.1355 46.4602C55.0441 41.9852 57.4314 36.3851 57.9536 30.4665C58.4759 24.548 57.1061 18.6164 54.0415 13.5261C51.1438 8.71294 46.8723 4.88688 41.7872 2.53333C41.3016 2.30857 41.0695 1.74187 41.2773 1.24879Z"/>
              </mask>
              <path d="M41.2773 1.24879C41.4852 0.755711 42.0543 0.523082 42.5404 0.746755C48.0033 3.26042 52.5923 7.36197 55.7017 12.5267C58.9778 17.9684 60.4422 24.3096 59.8839 30.6369C59.3256 36.9641 56.7734 42.9509 52.595 47.7349C48.4166 52.5189 42.8275 55.8532 36.6329 57.2576C30.4382 58.6619 23.9577 58.0639 18.1247 55.5495C12.2917 53.0352 7.40725 48.7344 4.17491 43.2665C0.942573 37.7986 -0.470841 31.4458 0.138246 25.1233C0.716322 19.1226 3.08787 13.4431 6.93273 8.81924C7.27486 8.4078 7.88861 8.37228 8.28879 8.72751C8.68897 9.08274 8.72396 9.69413 8.38275 10.1063C4.80976 14.4227 2.60582 19.7168 2.06709 25.3091C1.49735 31.2233 2.81946 37.1656 5.84302 42.2804C8.86657 47.3951 13.4355 51.4181 18.8917 53.77C24.348 56.122 30.4099 56.6814 36.2044 55.3677C41.999 54.0541 47.227 50.9352 51.1355 46.4602C55.0441 41.9852 57.4314 36.3851 57.9536 30.4665C58.4759 24.548 57.1061 18.6164 54.0415 13.5261C51.1438 8.71294 46.8723 4.88688 41.7872 2.53333C41.3016 2.30857 41.0695 1.74187 41.2773 1.24879Z" fill="#ED7904" stroke="#ED7904" stroke-opacity="0.1" stroke-width="2" mask="url(#path-1-inside-1_1_825)"/>
            </svg>
          </div>
          <div v-else class="d-flex align-items-center justify-content-center text-center otp-wait-success-block">
                                      <span v-if="!dataOtpFlags.sendingOtpError && !dataOtpFlags.confirmOtpStatus" class="otp-sent-seccess">Код успішно відправлено
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <rect width="20" height="20" fill="url(#pattern0)"/>
                                              <defs>
                                              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                              <use xlink:href="#image0_1_648" transform="scale(0.01)"/>
                                              </pattern>
                                              <image id="image0_1_648" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFfElEQVR4nO2caYgcRRTHO8Y7K15REbwVhXigKB54LCgbxu33ql6vNHiAYsQgeKEQBEFXEfygoigKBuKuuzOvJkxAMRKJVwz54okohpgPnnhLPGJMSNzsrtTOajbL7nb17szUdPf7QX3t+ff8u+pVVf+rg0AQBEEQBEEQBEEQBEEQBEEQBEEQhGxReq10ADHeQQZfJoZXiOHeuBZ3+NZVSOJa3KEZPyCDoxObZtwEDAt96yscZLBvshl7TIEXfesrFFSFxcQ4Mp0hxLg9GA3m+dZZCNQKdYg2+M20ZtQNGbmpv/NA31oLgWZ8dkYz6nXkM986C4GuhpdrA8OJhlThet9aCzHF1YybkswgxrekfrQAYnw80QyDW6EGJ7RCT6EhDi/UDLuTDYHbfGvNPXEt3t8W6cS6YXC9DFUtQBt82KFubMdBPK0VegoNGjxHM+xKMkQZuMe31tzT+U7nvsTwYXLvgPfiWjzft97coxnvcxiqdqLBM31rzT1Uvfp0zbDDYUV+v2+tuae3t3cfYtzgYMYnS5cv3c+33tyjDd7pMFQNEYfn+9aae3oq3SeSgb8cescjvrXmn9FgnmZ83WEB+LlsrbcAXcFbks2A4Z4KXtoKPYUmKkfHksHfHdYcT/jWWgjIpkaSNw6/6hrsWuBba+4hg9c5zKpGdBWu8q019wDDQm3gF4f3HM/51loIiHGlQ+/41gYbfGvNPVRBcOgZo5HBkm+tuSeuxYdqg985GNLnW2tQ9NQh7Vlz/BhyeLhvrbknMnjljKnD8aZMGPnWmnu6BrsWaINfOvSOqm+thUC7pA4NbIkGo6N9a809xHCJS+rQLhR9a809JcfUoTbwqm+thUAbfCzRDIY/o3LpON9ac48y6jxt4J/koUot8a21KFGejx16x9uZTB3aWGXE4Q3E+KRmfECV1aKgjSEDvQ5mbNNVfVKQNez4SgwbJ93MbptfCtoQXdFnu6QO7SnaIItohjdmeMpeaKdITFyL5091QnYKMzbY2E+QNXRVH59cFOFNu2kXtAHEsMxhqNphA3FBFlFGXeSwoLLvnDfaKE0WUofEsCzIKnFt8RGOq1ybWfpJGXVBW6cODb6f+YC0rRNOvaTe/qYK6lZrjAzc7jBU7YpWhmcFWSeuxQeRwTWupowdAWN1d7ulDonhwSAvjM9eEndMJxX75XaB1mxtZHCtgxmfttNssGHYJ9+1poy3tc0MCpBRSxymuEO+altLoAr2OM1mJjydzdi8ixxTh5rh0SDvRGW82DHX9N9T+r2udJ/bSA3E+JLDsLm5MAHpHg5PsYnwFMV+m+awuxG/HbG6NnmKC8PEcFlQJOrrFFyfoqcMzfWQPQ3QkU69k+GpoLBv5QxW0szANOPTs91L0gzGwYyvi/3Jvfqhl4dSTYsZV9k1TpqfiYwKHa47Ehnsat7NZgjFcLPbW7r/x/l341rpqAanDp9v/p1mCBvft++pUxT7L1RZnZF0XTKwwmGo+kH368Nac6cZwh6qT/wc3t415TdVUVfMPXWoVGvvNEOML9w+SlFTdtrXxJOvA6vhYNuLHK4x4OdOMxbhJIOrU5gyYicHE69BDM849LBfXWtR4bEbky5/Ku3d+uxmoGvqUDNcU/g/Oi32c9xpNib12Nlx2OzQq1aJGbNEM5D96FfK3jI6rWkGtqDBY8SQOX7HkBh+boQh0RSTAGEW4CCe7PTpVTNjWyN/fgOxx8bIwLpZmrHVRpTEkCZEVMngQHpDwlvFjGZvTHLySrzeYF0mA9JZQ3F4Y2Im187QqnSqb62FIbJ7Vgb+mHZWZeAu3xoLhyqrRVPvXUG/DFWeiGtxh40cESOPJScrCL60CIIgCIIgCIIgCIIgCIIgBO3Iv6h8/J8BCVIQAAAAAElFTkSuQmCC"/>
                                              </defs>
                                              </svg>
                                      </span>
                                      <span v-else-if="!dataOtpFlags.sendingOtpError && dataOtpFlags.confirmOtpStatus" class="otp-sent-seccess">Код підтверджено
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                              <rect width="20" height="20" fill="url(#pattern0)"/>
                                              <defs>
                                              <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                                              <use xlink:href="#image0_1_648" transform="scale(0.01)"/>
                                              </pattern>
                                              <image id="image0_1_648" width="100" height="100" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFfElEQVR4nO2caYgcRRTHO8Y7K15REbwVhXigKB54LCgbxu33ql6vNHiAYsQgeKEQBEFXEfygoigKBuKuuzOvJkxAMRKJVwz54okohpgPnnhLPGJMSNzsrtTOajbL7nb17szUdPf7QX3t+ff8u+pVVf+rg0AQBEEQBEEQBEEQBEEQBEEQBEEQhGxReq10ADHeQQZfJoZXiOHeuBZ3+NZVSOJa3KEZPyCDoxObZtwEDAt96yscZLBvshl7TIEXfesrFFSFxcQ4Mp0hxLg9GA3m+dZZCNQKdYg2+M20ZtQNGbmpv/NA31oLgWZ8dkYz6nXkM986C4GuhpdrA8OJhlThet9aCzHF1YybkswgxrekfrQAYnw80QyDW6EGJ7RCT6EhDi/UDLuTDYHbfGvNPXEt3t8W6cS6YXC9DFUtQBt82KFubMdBPK0VegoNGjxHM+xKMkQZuMe31tzT+U7nvsTwYXLvgPfiWjzft97coxnvcxiqdqLBM31rzT1Uvfp0zbDDYUV+v2+tuae3t3cfYtzgYMYnS5cv3c+33tyjDd7pMFQNEYfn+9aae3oq3SeSgb8cescjvrXmn9FgnmZ83WEB+LlsrbcAXcFbks2A4Z4KXtoKPYUmKkfHksHfHdYcT/jWWgjIpkaSNw6/6hrsWuBba+4hg9c5zKpGdBWu8q019wDDQm3gF4f3HM/51loIiHGlQ+/41gYbfGvNPVRBcOgZo5HBkm+tuSeuxYdqg985GNLnW2tQ9NQh7Vlz/BhyeLhvrbknMnjljKnD8aZMGPnWmnu6BrsWaINfOvSOqm+thUC7pA4NbIkGo6N9a809xHCJS+rQLhR9a809JcfUoTbwqm+thUAbfCzRDIY/o3LpON9ac48y6jxt4J/koUot8a21KFGejx16x9uZTB3aWGXE4Q3E+KRmfECV1aKgjSEDvQ5mbNNVfVKQNez4SgwbJ93MbptfCtoQXdFnu6QO7SnaIItohjdmeMpeaKdITFyL5091QnYKMzbY2E+QNXRVH59cFOFNu2kXtAHEsMxhqNphA3FBFlFGXeSwoLLvnDfaKE0WUofEsCzIKnFt8RGOq1ybWfpJGXVBW6cODb6f+YC0rRNOvaTe/qYK6lZrjAzc7jBU7YpWhmcFWSeuxQeRwTWupowdAWN1d7ulDonhwSAvjM9eEndMJxX75XaB1mxtZHCtgxmfttNssGHYJ9+1poy3tc0MCpBRSxymuEO+altLoAr2OM1mJjydzdi8ixxTh5rh0SDvRGW82DHX9N9T+r2udJ/bSA3E+JLDsLm5MAHpHg5PsYnwFMV+m+awuxG/HbG6NnmKC8PEcFlQJOrrFFyfoqcMzfWQPQ3QkU69k+GpoLBv5QxW0szANOPTs91L0gzGwYyvi/3Jvfqhl4dSTYsZV9k1TpqfiYwKHa47Ehnsat7NZgjFcLPbW7r/x/l341rpqAanDp9v/p1mCBvft++pUxT7L1RZnZF0XTKwwmGo+kH368Nac6cZwh6qT/wc3t415TdVUVfMPXWoVGvvNEOML9w+SlFTdtrXxJOvA6vhYNuLHK4x4OdOMxbhJIOrU5gyYicHE69BDM849LBfXWtR4bEbky5/Ku3d+uxmoGvqUDNcU/g/Oi32c9xpNib12Nlx2OzQq1aJGbNEM5D96FfK3jI6rWkGtqDBY8SQOX7HkBh+boQh0RSTAGEW4CCe7PTpVTNjWyN/fgOxx8bIwLpZmrHVRpTEkCZEVMngQHpDwlvFjGZvTHLySrzeYF0mA9JZQ3F4Y2Im187QqnSqb62FIbJ7Vgb+mHZWZeAu3xoLhyqrRVPvXUG/DFWeiGtxh40cESOPJScrCL60CIIgCIIgCIIgCIIgCIIgBO3Iv6h8/J8BCVIQAAAAAElFTkSuQmCC"/>
                                              </defs>
                                              </svg>
                                      </span>
                                     <span v-else class="otp-sent-error">Виникла помилка при відправленні ОТП коду, можливо пропозиція ще не готова, спробуйте ще раз
                                      <svg fill="red" height="20px" width="20px" version="1.1"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                             viewBox="0 0 490 490" xml:space="preserve">
                                              <polygon points="456.851,0 245,212.564 33.149,0 0.708,32.337 212.669,245.004 0.708,457.678 33.149,490 245,277.443 456.851,490
                                                489.292,457.678 277.331,245.004 489.292,32.337 "/>
                                              </svg>
                                      </span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="row" v-if="!hasAdditionalOtps">
            <div class="col-12">
              <div class="form-group">
                <div class="input-group">
                  <input v-model="otpPass" :disabled="dataOtpFlags.confirmOtpStatus" @input="otpChanged"
                         type="text"
                         placeholder="Введіть отримай код"
                         :class="['form-control', 'uppercase', {invalid: (!dataOtpFlags.otpCodeValidate && dataOtpFlags.submitOtpCheck)}]">
                  <div class="input-group-append">
                    <el-button :loading="dataOtpFlags.pandingOtpCheck" class="el-button btn btn-input-orange icon-arrow otp el-button--button" type="button" @click="otpCheck">
                      <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.29289L14.3431 0.928932C13.9526 0.538408 13.3195 0.538408 12.9289 0.928932C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM0 9H20V7H0V9Z" fill="white"/>
                      </svg>
                    </el-button>
                  </div>
                </div>
                <small class="error d-flex align-items-left"
                       v-if="!otpPass && dataOtpFlags.submitOtpCheck">Введіть код</small>
                <small class="error d-flex align-items-left"
                       v-else-if="otpPass && !dataOtpFlags.otpCodeValidate">Введено невірний код</small>
              </div>
            </div>
          </div>

          <div class="row" v-else>
            <div class="col-12">
              <div class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text otp-label">Код ОСЦПВ</span>
                  </div>
                  <input v-model="otpPass" :disabled="dataOtpFlags.confirmOtpStatus" @input="otpChanged"
                         type="text"
                         placeholder="Введіть код"
                         :class="['form-control', 'uppercase', {invalid: (!dataOtpFlags.otpCodeValidate && dataOtpFlags.submitOtpCheck)}]">
                </div>
              </div>

              <small class="error d-flex align-items-left" style="font-size: 11px; color: red; text-align: left;" v-if="additionalOtpWay && dataOrder">
                Для підписання ДЦВ буде направлено лист від СК {{ dataOrder.companyInfo.publicName }} {{ additionalOtpWay === 'sms' ? ' в смс' : ' на вказану електронну адресу'  }}
              </small>

              <div v-for="(code, key, index) in dataOtpFlags.additionalOtps" :key="key" class="form-group">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text otp-label">Код {{ key == 'cross' ? 'ДЦВ' : key }}</span>
                  </div>
                  <input v-model="additionalOtps[key]" :disabled="dataOtpFlags.confirmOtpStatus" @input="otpChanged"
                         type="text"
                         placeholder="Введіть код"
                         :class="['form-control', 'uppercase', {invalid: (!dataOtpFlags.otpCodeValidate && dataOtpFlags.submitOtpCheck)}]">
                  <div class="input-group-append">
                    <el-button v-if="index === Object.keys(dataOtpFlags.additionalOtps).length - 1"
                               :loading="dataOtpFlags.pandingOtpCheck"
                               class="el-button btn btn-input-orange icon-arrow otp el-button--button"
                               type="button"
                               @click="otpCheck">
                      <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.7071 8.70711C21.0976 8.31658 21.0976 7.68342 20.7071 7.29289L14.3431 0.928932C13.9526 0.538408 13.3195 0.538408 12.9289 0.928932C12.5384 1.31946 12.5384 1.95262 12.9289 2.34315L18.5858 8L12.9289 13.6569C12.5384 14.0474 12.5384 14.6805 12.9289 15.0711C13.3195 15.4616 13.9526 15.4616 14.3431 15.0711L20.7071 8.70711ZM0 9H20V7H0V9Z" fill="white"/>
                      </svg>
                    </el-button>
                  </div>
                </div>


              <small class="error d-flex align-items-left"
                     v-if="!allCodesEntered && dataOtpFlags.submitOtpCheck">Заповніть всі поля</small>
              <small class="error d-flex align-items-left"
                     v-else-if="allCodesEntered && !dataOtpFlags.otpCodeValidate && dataOtpFlags.submitOtpCheck">Введено невірний код</small>
              </div>
            </div>
          </div>


          <div v-if="!dataOtpFlags.confirmOtpStatus" class="row otp-resend-block text-left">
            <div class="col-12">
              <span>Не отримали код?</span>
              <a href="javascript:void(0);"  v-on:click="formSendOtp()">Відправити повторно</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <hr/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataConfirmContractStatus: Boolean,
    dataOtpFlags: Object,
    dataAgreement: Boolean,
    dataOrder: Object
  },
  data() {
    return {
      otpPass: "",
      additionalOtps: {},
      additionalOtpWay: null,
    };
  },
  created() {
    this.otpPass = this.dataOtpFlags.confirmOtpStatus ? (this.dataOtpFlags.otpPass || ""):"";
    this.additionalOtps = this.dataOtpFlags.additionalOtps ? { ...this.dataOtpFlags.additionalOtps } : {};
    this.additionalOtpWay = this.dataOtpFlags.additionalOtpWay ?? null;
  },

  methods: {
    formSendOtp() {
      this.$emit('formSendOtp');
    },
    otpCheck() {
      this.$emit('otpCheck', this.otpPass, this.additionalOtps);
    },
    otpChanged() {
      this.$emit('otpChanged');
    },
  },
  computed: {
    hasAdditionalOtps() {
      return this.dataOtpFlags.additionalOtps && Object.keys(this.dataOtpFlags.additionalOtps).length > 0;
    },
    allCodesEntered() {
      if (!this.otpPass) return false;
      if (this.hasAdditionalOtps) {
        return Object.keys(this.dataOtpFlags.additionalOtps).every(key => !!this.additionalOtps[key]);
      }
      return true;
    }
  },

  watch: {

    'dataOtpFlags.additionalOtps': {
      handler(newVal) {
        this.additionalOtps = newVal ? { ...newVal } : {};
      },
      deep: true,
    },
    'dataOtpFlags.otpPass': {
      handler(newVal) {
        if (this.dataOtpFlags.confirmOtpStatus) {
            this.otpPass = newVal || "";
        }
      }
    },
    'dataOtpFlags.additionalOtpWay': {
      handler(newVal) {
        if (this.dataOtpFlags.additionalOtpWay) {
          this.additionalOtpWay = newVal || null;
        }
      }
    },
  }
}

</script>

<style scoped>
.otp-label {
  width: 110px;
  height: 40px;
  justify-content: center;
}
.invisible-spacer {
  visibility: hidden;
  pointer-events: none;
}
</style>


